module.exports = __webpack_public_path__ + "img/1920_online_ticket_qr.5a36e299.svg";